import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconReturnRightSet extends Component<SVGIconSearchProps> {
  render() {
    const { width = 7, height = 14, color = '#11465D', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 7 14`}
        fill={color}
        {...rest}
      >
        <g>
          <path
            d="M1.17751 0L6.4351 5.55333C6.79689 5.93671 7 6.4556 7 6.9965C7 7.5374 6.79689 8.05629 6.4351 8.43967L1.17087 14L0 12.7627L5.26423 7.203C5.31607 7.1483 5.3452 7.07413 5.3452 6.99679C5.3452 6.91945 5.31607 6.84528 5.26423 6.79058L0.00608492 1.23725L1.17751 0Z"
            fill={color}
          />
        </g>
      </SVG>
    );
  }
}
